import React from "react";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";

const TermsConditions = () => {
  return (
    <>
      <Navbar />

      <main className="legal-page">
        <div className="legal-container">
          <div className="legal-hero">
            <span className="legal-chip">Legal</span>
            <h1>Terms & Conditions</h1>
            <p className="legal-intro">
              These Terms and Conditions govern your use of the Simba Solution website
              and related services.
            </p>
            <p className="legal-date">Last updated: May 19, 2026</p>
          </div>

          <div className="legal-card">
            <section className="legal-block">
              <h2>1. About Us</h2>
              <p>
                Simba Solution is a UK-based digital solutions company focused on
                logistics, freight forwarding, and related technology services.
              </p>
            </section>

            <section className="legal-block">
              <h2>2. Use of the Website</h2>
              <p>
                You agree to use this website only for lawful purposes and in a
                way that does not infringe or restrict the rights of others.
              </p>
            </section>

            <section className="legal-block">
              <h2>3. Intellectual Property</h2>
              <p>
                All content on this website, including text, graphics, branding,
                logos, and design elements, is owned by or licensed to Simba Solution
                unless otherwise stated.
              </p>
            </section>

            <section className="legal-block">
              <h2>4. Information and Services</h2>
              <p>
                Information on this website is provided for general information only.
                We do not guarantee that all content is always complete, accurate,
                or up to date.
              </p>
            </section>

            <section className="legal-block">
              <h2>5. Third-Party Links</h2>
              <p>
                Our website may include links to third-party services or websites.
                Simba Solution is not responsible for their content, terms, or privacy practices.
              </p>
            </section>

            <section className="legal-block">
              <h2>6. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, Simba Solution shall not
                be liable for any direct, indirect, incidental, or consequential damages
                arising from the use of this website.
              </p>
            </section>

            <section className="legal-block">
              <h2>7. No Warranty</h2>
              <p>
                This website is provided on an “as is” and “as available” basis,
                without warranties of any kind, express or implied.
              </p>
            </section>

            <section className="legal-block">
              <h2>8. User Conduct</h2>
              <ul>
                <li>Do not use the website unlawfully</li>
                <li>Do not attempt unauthorized access</li>
                <li>Do not transmit malware or malicious code</li>
                <li>Do not interfere with website security or performance</li>
              </ul>
            </section>

            <section className="legal-block">
              <h2>9. Privacy</h2>
              <p>
                Your use of this website is also subject to our Privacy Policy.
              </p>
            </section>

            <section className="legal-block">
              <h2>10. Changes to These Terms</h2>
              <p>
                We may update these Terms and Conditions at any time by posting a
                revised version on this page.
              </p>
            </section>

            <section className="legal-block">
              <h2>11. Governing Law</h2>
              <p>
                These Terms and Conditions shall be governed by the applicable laws
                of the United Kingdom, unless otherwise required by law.
              </p>
            </section>

            <section className="legal-block">
              <h2>12. Contact Us</h2>
              <p>
                If you have any questions regarding these Terms and Conditions,
                please contact us through the website contact section.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default TermsConditions;
